import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useRouteMatch } from "react-router-dom";

import _ from "lodash";
import cx from 'classnames';
import CreatableSelect from 'react-select/creatable';
import { IKImage } from 'imagekitio-react';
import { toast } from "react-toastify";
import { SuccessToast } from "components/Toast";
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { useDrag, useDrop } from "react-dnd";

import { MediaLibraryModal } from 'components/MediaLibrary';
import StoryboardContext from 'components/Storyboard/context';

import {
  updateWidgetName, updatePageSettings, bulkUpdateWidgetOrder, switchInteractivePageSection,
  actionGroup, deleteWidgets, createInteractivePageSection, clonePage,
  updateWidgetProperty
} from 'actions/editor';
import Sticky from "react-sticky-el";
import {
  Container,
  Row,
  Col,
  OverlayTrigger,
  Popover,
  Tab,
  Image,
  TabContainer,
  Form,
  FormCheck,
  Modal,
  Button,
  Accordion,
  Nav
} from "react-bootstrap";
import TruncatedTextWithTooltip from "components/TruncatedTextWithTooltip";

import { GatingList, GatingForm } from 'pages/pages/gating/settings';
import storyboardRoleService from "services/storyboardRoles.service";
import { getBaseUrl } from "services/util";
import { PAGE } from "constants/widgetTypes";

import styles from "./pageSettings.module.scss";



export default function PageSettings({ editorSession, defaultParent, onClose, type }) {
  const dispatch = useDispatch();
  const history = useHistory();

  let { url } = useRouteMatch();
  let baseUrl = getBaseUrl(url);

  const listReference = React.createRef(null);
  const [isDragging, setIsDragging] = useState(false);

  const [state, setState] = useState({
    selected: null,
    selectedGating: null
  })

  const activePage = useSelector(state => {
    const active = _.get(state, `${editorSession}.present.interactive.active`);
    const widgets = _.get(state, `${editorSession}.present.widgets`) || [];
    return widgets.find(item => item.uid === active);
  });

  const activePageId = _.get(activePage, 'uid', null);

  let pages = [];

  pages = useSelector(state => {
    const widgets = _.get(state, `${editorSession}.present.widgets`) || [];
    var pages = widgets.filter(item => item.type === PAGE);
    pages = _.sortBy(pages, 'order');
    return pages;
  });
  
  const items = useSelector(state => _.get(state, 'storyboards.storyboard.pages.items', []));
  if(type === 'gating') {
    pages = items;
  }

  const selectedPage = pages.find(item => item.uid === _.get(state, 'selected.uid'));
  const selectedPageAlias = _.get(selectedPage, 'properties.desktop.alias', '');

  useEffect(() => {
    setState(state => {
      return {
        ...state,
        selected: activePage,
        request: buildRequest(activePage),
        pageInfo: {
          name: _.get(activePage, 'name', ''),
          alias: _.get(activePage, 'properties.desktop.alias', ''),
          autoCreateAlias: _.get(activePage, 'properties.desktop.autoCreateAlias'),
        },
        seoInfo: _.get(activePage, 'properties.desktop.seo', {}),
        socialInfo: _.get(activePage, 'properties.desktop.social', {}),
        twitterInfo: _.get(activePage, 'properties.desktop.twitter', {})
      }
    })

    if (!listReference.current) {
      return;
    }

  }, [activePageId]);

  useEffect(() => {
    if (!listReference.current) {
      return;
    }
  }, [pages]);

  useEffect(() => {
    if (selectedPage) {
      setState((state) => {
        return {
          ...state,
          selected: selectedPage
        }
      });
    }
  }, [selectedPage]);

  useEffect(() => {
    if (activePage) {
      const previousPage = _.get(activePage, 'uid');
      const nextPage = _.get(state.selected, 'uid');

      if (previousPage !== nextPage) {
        handlePageClick(activePage, false);
      }
    }
  }, [activePage]);

  useEffect(() => {
    if (selectedPage) {
      setState((state) => {
        return {
          ...state,
          selected: selectedPage,
          request: buildRequest(selectedPage),
          pageInfo: {
            name: _.get(selectedPage, 'name', ''),
            alias: _.get(selectedPage, 'properties.desktop.alias', ''),
            autoCreateAlias: _.get(selectedPage, 'properties.desktop.autoCreateAlias'),
          },
          seoInfo: _.get(selectedPage, 'properties.desktop.seo', {}),
          socialInfo: _.get(selectedPage, 'properties.desktop.social', {}),
          twitterInfo: _.get(selectedPage, 'properties.desktop.twitter', {})
        }
      });
    }
  }, [selectedPageAlias]);

  useEffect(() => {
    if (pages.length > 1) {
      listReference?.current?.querySelector(':scope > :last-child')?.scrollIntoView();
    }
  }, [pages.length])

  const hasUnsavedChanges = () => {
    const previousPage = state.selected;

    var savedRequest = buildRequest(previousPage);
    var request = state.request;

    savedRequest = _.omit(savedRequest, 'errors');
    request = _.omit(request, 'errors');

    const changed = savedRequest != null && request != null && !_.isEqual(savedRequest, request);
    return changed;
  }

  const buildRequest = (page) => {
    if (page == null) {
      return null;
    }
    
    const request = {
      uid: _.get(page, 'uid'),
      info: {
        name: _.get(page, 'name', ''),
        alias: _.get(page, 'properties.desktop.alias', ''),
        autoCreateAlias: _.get(page, 'properties.desktop.autoCreateAlias')
      },
      seo: _.get(page, 'properties.desktop.seo', {}),
      social: _.get(page, 'properties.desktop.social', {}),
      twitter: _.get(page, 'properties.desktop.twitter', {}),
    };

    return request;
  }

  //Force variable to override unsaved changes
  const handlePageClick = (page, force) => {
    const changed = hasUnsavedChanges();

    if (changed && !force) {
      setState(state => {
        return {
          ...state,
          nextPage: page,
          unsavedChanges: changed
        }
      })

      return;
    }

    setState(state => {
      return {
        ...state,
        selected: page,
        selectedGating: null,
        nextPage: null,
        request: buildRequest(page),
        unsavedChanges: false
      }
    });
  }

  const handlePageGating = (page) => {
    history.push(`${baseUrl}/pages/${page.page}?active=${page.uid}`)
  }

  const handleAddPageClick = () => {
    const changed = hasUnsavedChanges();
    if (changed) {
      setState(state => {
        return {
          ...state,
          nextPage: null,
          unsavedChanges: changed
        }
      })

      return;
    }

    dispatch(createInteractivePageSection(editorSession, pages.length + 1));
  }

  const handlePageChange = (request) => {
    setState((state) => {
      return {
        ...state,
        request: request
      };
    })
  }

  const validateForm = (request) => {
    const name = _.get(request, 'info.name') || '';
    const alias = _.get(request, 'info.alias') || '';
    const autoCreateAlias = _.get(request, 'info.autoCreateAlias');

    let errors = {};
    var aliasRegex = /^[a-z_-]|[`\s!@#$%^&*()+\=\[\]{};':"\\|,.<>\?~]/;
    var slashRegex = /([^:]\/)\/+/

    if (name.trim() === '') {
      errors['name'] = 'Please provide a valid name';
    }

    if (!autoCreateAlias) {
      if (alias.trim() === '' || aliasRegex.test(alias) || slashRegex.test(alias)) {
        errors['alias'] = 'Please provide valid alias';
      } else if (alias.startsWith('//')) {
        errors['alias'] = 'Alias should begin with /';
      }
    }

    let aliasExists = pages.some(item => {
      var existingAlias = _.get(item, 'properties.desktop.alias');
      return alias && item.uid !== state.selected.uid && existingAlias === alias;
    })

    if (aliasExists) {
      errors['alias'] = 'Alias already exist';
    }

    return errors;
  }

  const handleSaveChanges = () => {
    const page = state.selected;
    const request = state.request;

    let errors = validateForm(state.request);

    setState(state => {
      return {
        ...state,
        unsavedChanges: false,
        request: {
          ...state.request,
          errors: errors
        }
      }
    });

    if (Object.keys(errors).length > 0) {
      return false;
    }

    const name = _.get(request, 'info.name');
    const alias = _.get(request, 'info.alias');
    const autoCreateAlias = _.get(request, 'info.autoCreateAlias');

    actionGroup.start();

    dispatch(updateWidgetName(editorSession, page.uid, name));

    dispatch(updatePageSettings(editorSession, null, page.uid, 'desktop', {
      alias: alias,
      autoCreateAlias: autoCreateAlias,
      seo: request.seo,
      social: request.social,
      twitter: request.twitter
    }));

    actionGroup.end();

    setState(state => {
      return {
        ...state,
        unsavedChanges: false
      }
    });

    toast(
      <SuccessToast
        heading={`Success`}
        description={`${_.get(page, 'name')} changes saved successfully`}
      />,
      {
        type: toast.TYPE.DEFAULT,
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 3000,
      }
    );

    return true;
  }

  const handleResetClick = () => {
    setState((state) => {
      const request = buildRequest(state.selected);
      return {
        ...state,
        request: request,
        unsavedChanges: false
      }
    });
  }

  return (
    <section className={styles.pageSettings}>
      <div className={styles.pages} style={{ width: type !== 'page' && '300px' }}>
        <div className={styles.pagesWrapper}>
            <div className={styles.inner} ref={listReference}>
              {pages.map((page, index) => {
                return (
                  <PageItem
                    key={page.uid}
                    editorSession={editorSession}
                    type = {type}
                    page={page}
                    pages={pages}
                    selected={state.selected}
                    onClick={(page,force) => type === 'gating' ? handlePageGating(page) : handlePageClick(page, force)}
                    index={index}
                    onDragStart={() => setTimeout(() => setIsDragging(true), 10)}
                    onDragEnd={() => setTimeout(() => setIsDragging(false), 20)}
                  />
                );
              })}
            </div>
            
          {!isDragging && <Sticky mode='bottom' scrollElement={`.${styles.pagesWrapper}`} boundaryElement={`.${styles.pageSettings}`}>
            <div className={styles.addPageButtonContainer}>
              <Button variant='primary' onClick={handleAddPageClick}>
                <i className={cx('cleverstory-plus', styles.icon)} />
                Add Page
              </Button>
            </div>
          </Sticky>}
        </div>
      </div>

      {state.selected && !state.selectedGating && type === 'page' &&
        <PageSettingForm
          editorSession={editorSession}
          page={state.selected}
          value={state.request}
          onChange={handlePageChange}
          onSave={handleSaveChanges}
          onReset={handleResetClick}
          selectedPage={selectedPage}
        />
      }

      <SaveMessageModal
        show={state.unsavedChanges}
        onDiscard={() => {
          handleResetClick();
          if (state.nextPage) {
            handlePageClick(state.nextPage, true);
          }
        }}
        onSave={() => {

          const saved = handleSaveChanges();
          if (saved && state.nextPage) {
            handlePageClick(state.nextPage, true);
          }
        }}
      />
    </section>
  );
}

const PageItem = ({ editorSession, page, type, pages, selected, onClick, index, isDraggable, onDragStart, onDragEnd }) => {
  const dispatch = useDispatch();

  var active = _.get(page, 'uid', null) === _.get(selected, 'uid', null);
  const ref = useRef(null);
  const [newIndex, setNewIndex] = useState(null);
  const [oldIndex, setOldIndex] = useState(null);
  const storyboard = useSelector((state) => _.get(state, "storyboards.storyboard.item", null));
  let visible = _.get(page, 'properties.desktop.visible', true);
  if (type === 'gating'){
   visible =  _.get(page, 'visible')
  }
  const visiblePages = pages.filter(
    (item) => item.properties?.desktop?.visible === true
  );  

  const handleDeleteClick = (e) => {
    e.stopPropagation();
    document.body.click();

    dispatch(deleteWidgets(editorSession, [page.uid]));
    handleNextPage()
  }

  const handleCloneClick = (e) => {
    e.stopPropagation();
    document.body.click();

    dispatch(clonePage(editorSession, page.uid));
  }

  const handleMove = (oldIndex, newIndex) => {
    if (oldIndex === newIndex) {
      return;
    }

    var items = pages || [];

    var element = items[oldIndex];

    items.splice(oldIndex, 1);
    items.splice(newIndex, 0, element);

    var order = 0;
    var request = items.map(item => {
      order++;

      return {
        uid: item.uid,
        order: order
      }
    });

    dispatch(bulkUpdateWidgetOrder(editorSession, request));
  }

  const handleNextPage = () => {
    const deletedPage = pages.findIndex(pagedata => pagedata.uid === page.uid)
    const nextPage = pages[deletedPage + 1] || pages[deletedPage - 1] || pages[deletedPage];
    dispatch(switchInteractivePageSection(editorSession, nextPage.uid));
    onClick(nextPage)
  }

  const handleInteractivePageVisibility = () => {
      dispatch(updateWidgetProperty(editorSession, page.uid, 'desktop', {
        visible: !visible
      }));
  }

  const [{ handlerId, isOver }, drop] = useDrop({

    accept: 'page', // Accepts only the item with PAGE type
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
    hover(item, monitor) {
      const dragIndex = item.index;
      const hoverIndex = index;

      if (dragIndex === hoverIndex) {
        return;
      }

      setNewIndex(hoverIndex);
      setOldIndex(dragIndex);
    },
    drop(item, monitor) {
      handleMove(oldIndex, newIndex);
    }
  })

  const [{ isDragging }, drag, preview] = useDrag({
    type: 'page',
    item: () => {
      return { type: "page", uid: page.uid, index }
    },
    canDrag: isDraggable,
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  })

  const opacity = isDragging ? 0.5 : 1

  const style = {
    transform: 'translate(0, 0)'
  }

  drag(drop(ref));

  const popover = (
    <Popover bsPrefix="popover" className={styles.pageSettingsPopover}>
      <Popover.Body className={styles.pageSettingsPopoverBody}>
        <div className={styles.pageSettingsPopoverContent}>
          <span onClick={handleCloneClick}>Clone</span>
          {(visiblePages.length > 1 || (visiblePages.length === 1 && visiblePages[0].uid !== page.uid)) && <span onClick={handleInteractivePageVisibility}> {visible ? 'Hide' : 'Unhide'} </span>}
          {pages.length > 1 && storyboardRoleService.canManageStoryboard(storyboard) && !(visiblePages.length === 1 && visiblePages[0].uid === page.uid) && (
            <span onClick={handleDeleteClick}>Delete</span>
          )}
        </div>
      </Popover.Body>
    </Popover>
  );

  const handlePageClick = () => {
    onClick(page);
  }

  return (
    <div ref={ref} id={page.id} key={page.uid} style={{ opacity }} data-handler-id={handlerId} onDragStart={() => onDragStart()} onDragEnd={() => onDragEnd()}>
      <div style={style} className={cx(styles.pageItem, { [styles.hover]: isOver }, { [styles.selected]: active })} onClick={() => handlePageClick()} ref={preview}>
        <Handle />
        <TruncatedTextWithTooltip className={styles.name} placement="top" maxWidth={180} content={page.name}>
          {page.name}
        </TruncatedTextWithTooltip>
        {!visible &&
          <i className={cx('cleverstory-hide', styles.iconHide)}></i>
        }
        <OverlayTrigger
          rootClose
          trigger="click"
          placement="right"
          overlay={popover}
        >
          <i className={cx('cleverstory-more', styles.iconMore)} />
        </OverlayTrigger>
      </div>
    </div>
  )
}

const PageSettingForm = ({ editorSession, page, value, onChange, onSave, onReset, selectedPage }) => {
  const [state, setState] = useState({
    active: 'info'
  })

  const handleMenuChange = (active) => {
    setState(state => {
      return {
        ...state,
        active: active
      }
    })
  }

  useEffect(() => {
    if (page.id) {
      setState(state => {
        return {
          ...state,
          active: 'info'
        }
      })
    }
  }, [page.id]);

  const handleInfoChange = (change) => {
    const request = {
      ...value,
      info: {
        ...value.info,
        ...change
      }
    };

    onChange(request);
  }

  const handleSEOChange = (change) => {
    const request = {
      ...value,
      seo: {
        ...value.seo,
        ...change
      }
    };

    onChange(request);
  }

  const handleSocialChange = (type, change) => {
    const request = {
      ...value,
      [type]: {
        ...value[type],
        ...change
      }
    };

    onChange(request);
  }

  return (
    <div className={cx(styles.pageSettingForm, { [styles.maxWidth]: state.active == 'manageAlias' })}>
      <Container fluid>
        <TabContainer defaultActiveKey={'info'} activeKey={state.active} onSelect={handleMenuChange}>
          <Row>
            <Col sm={state.active == 'manageAlias' ? 3 : 4} className={styles.options}>
              <Nav className="flex-column">
                <Nav.Item>
                  <Nav.Link eventKey="info">Page Info</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="seo">SEO Basics</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="social">Social Share</Nav.Link>
                </Nav.Item>
              </Nav>
            </Col>
            <Col sm={state.active == 'manageAlias' ? 9 : 8} className={cx(styles.pageSettingsDetail)}>
              <Tab.Content>
                <Tab.Pane eventKey="info">
                  <PageInfo editorSession={editorSession} value={value} onChange={handleInfoChange} selectedPage={selectedPage} />
                </Tab.Pane>
                <Tab.Pane eventKey="seo">
                  <SEOBasics editorSession={editorSession} value={value} onChange={handleSEOChange} />
                </Tab.Pane>
                <Tab.Pane eventKey="social">
                  <SocialShare editorSession={editorSession} page={page} value={value} onChange={handleSocialChange} />
                </Tab.Pane>
                {state.active !== "manageAlias" &&
                  <footer className={styles.buttonContainer}>
                    <Button className={styles.actionButton} variant="secondary" type="reset" onClick={onReset}>Reset</Button>
                    <Button variant="primary" type="submit" onClick={onSave}>Save Changes</Button>
                  </footer>
                }
              </Tab.Content>

            </Col>
          </Row>
        </TabContainer>
      </Container>
    </div>
  )
}

const PageInfo = ({ editorSession, value, onChange, selectedPage }) => {
  const dispatch = useDispatch();
  const errors = _.get(value, 'errors') || {};
  const autoCreateAlias = _.get(value, 'info.autoCreateAlias');
  const pages = useSelector(state => {
    const widgets = _.get(state, `${editorSession}.present.widgets`) || [];
    var pages = widgets.filter(item => item.type === PAGE);
    pages = _.sortBy(pages, 'order');
    return pages;
  });
  const activePage = pages.find((item) => item.uid === selectedPage?.uid);
  const visible = _.get(activePage, 'properties.desktop.visible', true);
  const visiblePages = pages.filter(
    (item) => item.properties?.desktop?.visible === true
  );
  
  const handleInteractivePageVisibility = () => {
    dispatch(updateWidgetProperty(editorSession, activePage.uid, 'desktop', {
      visible: !visible
    }));
}

  const handleNameChange = (e) => {
    const value = e.target.value;
    onChange({
      name: value
    });
  }

  const handleAliasChange = (e) => {
    const value = e.target.value;
    onChange({
      alias: value
    });
  }

  const toggleAutoCreateAlias = (e) => {
    onChange({
      autoCreateAlias: !autoCreateAlias
    });
  }

  return (
    <div className={styles.pageInfo}>
      <h3 className={styles.header}>Page Info</h3>
      <Form className={styles.form}>
        <Form.Group controlId="pageName" className={styles.group}>
          <Form.Label className={styles.label}>Page Name</Form.Label>
          <Form.Control isInvalid={errors.name}
            className={styles.control}
            type="text"
            name="name"
            placeholder="Enter page name"
            value={_.get(value, 'info.name', '')}
            onChange={handleNameChange} />
          <Form.Control.Feedback type="invalid">
            {errors.name || 'please provide a valid name'}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group controlId="pageAlias" className={styles.group}>
          <Form.Label className={styles.label}>Page URL Slug (last part of the URL)</Form.Label>
          <Form.Control isInvalid={errors.alias}
            className={styles.control}
            type="text"
            name="alias"
            placeholder="Enter page alias"
            disabled={_.get(value, 'info.autoCreateAlias')}
            value={_.get(value, 'info.alias', '')}
            onChange={handleAliasChange}
          />
          <Form.Check
            className={styles.checkbox}
            type="checkbox"
            label="Auto generate alias"
            checked={_.get(value, 'info.autoCreateAlias')}
            onChange={toggleAutoCreateAlias}
          />
          <Form.Control.Feedback type="invalid" >
            {errors.alias || 'please provide valid alias'}
          </Form.Control.Feedback>
        </Form.Group>
        {(visiblePages.length > 1 || (visiblePages.length === 1 && visiblePages[0].uid !== activePage?.uid)) &&
          <Form.Group controlId="indexing" className={cx(styles.smallGroup, styles.flexFormGroup)}>
            <Form.Label className={styles.inlineLabel}>Hide this page</Form.Label>
            <Form.Check
              type="switch"
              className={styles.switchButton}
            >
            <FormCheck.Input isvalid onChange={handleInteractivePageVisibility} checked={!visible} />
            </Form.Check>
          </Form.Group>
        }
      </Form>
    </div>
  )
}

const SEOBasics = ({ value, onChange }) => {
  const [nameFocused, setNameFocused] = useState(false);

  const pageName = _.get(value, 'info.name', '');
  const name = _.get(value, 'seo.name') || pageName;
  const description = _.get(value, 'seo.description') || '';
  const excludeFromSearch = _.get(value, 'seo.excludeFromSearch', false)
  const keywords = (_.get(value, 'seo.keywords') || []).map(item => {
    return {
      label: item,
      value: item
    }
  });

  const handleNameChange = (e) => {
    const value = e.target.value;
    onChange({
      name: value
    });
  }

  const handleDescriptionChange = (e) => {
    const value = e.target.value;
    onChange({
      description: value
    });
  }

  const handleKeywordsChange = (data) => {
    const keywords = data.map(item => item.value);
    onChange({
      keywords: keywords
    });
  }

  const handleToggleExcludeFromSearch = (e) => {
    onChange({
      excludeFromSearch: !excludeFromSearch
    });
  }

  return (
    <>
      <div className={styles.seoBasics}>
        <h3 className={styles.header}>SEO Basics</h3>
        <Form className={styles.form}>
          <Form.Group controlId="pageTitle" className={styles.group}>
            <Form.Label className={styles.label}>Title Tag</Form.Label>
            <Form.Control
              className={styles.control}
              type="text"
              name="name"
              placeholder="Enter page title"
              value={nameFocused ? _.get(value, 'seo.name') : name}
              onChange={handleNameChange}
              onFocus={() => { setNameFocused(true) }}
              onBlur={() => { setNameFocused(false) }} />
          </Form.Group>
          <Form.Group controlId="pageDescription" className={styles.group}>
            <Form.Label className={styles.label}>Meta Description</Form.Label>
            <Form.Control
              as="textarea"
              className={styles.control}
              type="text"
              name="description"
              placeholder="Enter page description"
              value={description}
              onChange={handleDescriptionChange} />
          </Form.Group>
          <Form.Group controlId="PageMetaTags" className={styles.group}>
            <Form.Label className={styles.label}>Meta Tags</Form.Label>
            <CreatableSelect
              className={styles.select}
              classNamePrefix="select"
              name="keywords"
              isMulti
              options={[]}
              value={keywords}
              onChange={handleKeywordsChange}
            />
          </Form.Group>
        </Form>
      </div>
    </>
  )
}

const SocialShare = ({ value, onChange }) => {
  const [state, setState] = useState({
    library: false,
    nameFocused: false,
    descriptionFocused: false
  });

  const storyboardContext = React.useContext(StoryboardContext);

  const pageName = _.get(value, 'info.name', '');
  const pageAlias = _.get(value, 'info.alias', '');

  const seoName = _.get(value, 'seo.name') || pageName;
  const seoDescription = _.get(value, 'seo.description') || '';

  const name = _.get(value, 'social.name') || seoName;
  const description = _.get(value, 'social.description') || seoDescription;
  const icon = _.get(value, 'social.icon.url');

  const handleUploadLibrary = () => {
    setState(state => {
      return {
        ...state,
        library: true
      }
    });
  }

  const handleCloseMediaLibrary = () => {
    setState(state => {
      return {
        ...state,
        library: false
      }
    });
  }

  const handleCreateImage = (medias) => {
    const media = medias[0];
    onChange('social', {
      icon: media
    });

    handleCloseMediaLibrary();
  }

  const handleNameChange = (e) => {
    const value = e.target.value;
    onChange('social', {
      name: value
    });
  }

  const handleDescriptionChange = (e) => {
    const value = e.target.value;
    onChange('social', {
      description: value
    });
  }

  return (
    <>
      <div className={styles.socialShare}>
        <h3 className={styles.header}>Social Share Settings</h3>

        <p className={styles.subHeader}>Social Preview</p>
        <section className={styles.preview}>
          <div className={styles.inner} onClick={handleUploadLibrary.bind(this, 'socialInfo')}>
            <div className={styles.image}>
              {icon &&
                <IKImage
                  path={icon}
                  transformation={[{
                    height: 400,
                    format: 'webp'
                  }]}
                />
              }
              <div className={styles.upload}>
                <i className={cx('cleverstory-upload', styles.icon)} />
                <span className={styles.lable}>Upload Media</span>
              </div>
            </div>

            <div className={styles.details}>
              <div className={styles.url}>
                {pageAlias}
              </div>
              <div className={styles.title}>{name}</div>
              <div className={styles.description}>
                {description}
              </div>
            </div>
          </div>
        </section>

        <Form className={styles.form}>
          <Form.Group controlId="pageTitle" className={styles.group}>
            <Form.Label className={styles.label}>Page Name</Form.Label>
            <Form.Control
              className={styles.control}
              type="text"
              name="name"
              placeholder="Enter page title"
              value={state.nameFocused ? _.get(value, 'social.name') : name}
              onChange={handleNameChange}
              onFocus={() => {
                setState(state => {
                  return {
                    ...state,
                    nameFocused: true
                  }
                })
              }}
              onBlur={() => {
                setState(state => {
                  return {
                    ...state,
                    nameFocused: false
                  }
                })
              }} />
          </Form.Group>
          <Form.Group controlId="pageDescription" className={styles.group}>
            <Form.Label className={styles.label}>Meta description</Form.Label>
            <Form.Control
              as="textarea"
              className={styles.control}
              type="text"
              name="description"
              placeholder="Enter page description"
              value={state.descriptionFocused ? _.get(value, 'social.description') : description}
              onChange={handleDescriptionChange}
              onFocus={() => {
                setState(state => {
                  return {
                    ...state,
                    descriptionFocused: true
                  }
                })
              }}
              onBlur={() => {
                setState(state => {
                  return {
                    ...state,
                    descriptionFocused: false
                  }
                })
              }} />
          </Form.Group>
        </Form>

        <Accordion className={styles.twitterAccordion}>
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              Twitter Settings
            </Accordion.Header>
            <Accordion.Body>
              <TwitterSettings value={value} onChange={onChange} />
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
      <MediaLibraryModal
        show={state.library}
        storyboard={storyboardContext}
        multiple={false}
        onSelect={handleCreateImage}
        onClose={handleCloseMediaLibrary}
        mediaTarget={'social_share'}
      />
    </>
  )
}

const TwitterSettings = ({ value, onChange }) => {
  const [state, setState] = useState({
    library: false,
    nameFocused: false,
    descriptionFocused: false
  });

  const storyboardContext = React.useContext(StoryboardContext);

  const pageName = _.get(value, 'info.name', '');
  const pageAlias = _.get(value, 'info.alias', '');

  const seoName = _.get(value, 'seo.name') || pageName;
  const seoDescription = _.get(value, 'seo.description') || '';

  const socialName = _.get(value, 'social.name') || seoName;
  const socialDescription = _.get(value, 'social.description') || seoDescription;
  const socialIcon = _.get(value, 'social.icon.url');

  const name = _.get(value, 'twitter.name') || socialName;
  const description = _.get(value, 'twitter.description') || socialDescription;
  const icon = _.get(value, 'twitter.icon.url') || socialIcon;
  const size = _.get(value, 'twitter.size') || 'large';

  const handleNameChange = (e) => {
    const value = e.target.value;
    onChange('twitter', {
      name: value
    });
  }

  const handleDescriptionChange = (e) => {
    const value = e.target.value;
    onChange('twitter', {
      description: value
    });
  }

  const handleCardTypeChange = (size) => {
    onChange('twitter', {
      size: size
    });
  }

  const handleUploadLibrary = () => {
    setState(state => {
      return {
        ...state,
        library: true
      }
    });
  }

  const handleCloseMediaLibrary = () => {
    setState(state => {
      return {
        ...state,
        library: false
      }
    });
  }

  const handleCreateImage = (medias) => {
    const media = medias[0];
    onChange('twitter', {
      icon: media
    });

    handleCloseMediaLibrary();
  }

  return (
    <div className={styles.socialShare}>
      <Form className={styles.form}>
        <Form.Group controlId="pageSize" className={cx(styles.group, styles.twitterSettings)}>
          <Form.Label className={styles.label}>Card size on twitter</Form.Label>
          <div className={styles.cardTypeWrapper}>
            <div className={cx(styles.cardType)} onClick={() => handleCardTypeChange('large')}>
              <input type="radio" checked={size === 'large'} onChange={() => handleCardTypeChange('large')}></input>
              <label>Large</label>
            </div>
            <div className={cx(styles.cardType)} onClick={() => handleCardTypeChange('small')}>
              <input type="radio" checked={size === 'small'} onChange={() => handleCardTypeChange('small')}></input>
              <label>Small</label>
            </div>
          </div>
        </Form.Group>
      </Form>
      <p className={styles.subHeader}>Preview on twitter</p>

      <section className={cx(styles.preview, styles.twitter, {
        [styles.small]: size == 'small'
      }
      )}>
        <div className={styles.inner} onClick={handleUploadLibrary}>
          <div className={styles.image}>
            {icon &&
              <IKImage
                path={icon}
                transformation={[{
                  height: 400,
                  format: 'webp'
                }]}
              />
            }
            {!icon && <div className={styles.upload}>
              <i className={cx('cleverstory-upload', styles.icon)} />
              <span className={styles.label}>Choose Media</span>
            </div>}
          </div>

          <div className={styles.details}>
            <div className={styles.url}>
              {pageAlias}
            </div>
            <div className={styles.title}>
              {name}
            </div>
            <div className={styles.description}>
              {description}
            </div>
          </div>
        </div>
      </section>

      <Form className={styles.form}>
        <Form.Group controlId="pageTitle" className={styles.group}>
          <Form.Label className={styles.label}>What’s this page name?</Form.Label>
          <Form.Control
            className={styles.control}
            type="text"
            placeholder="Enter page title"
            name="name"
            value={state.nameFocused ? _.get(value, 'twitter.name') : name}
            onChange={handleNameChange}
            onFocus={() => {
              setState(state => {
                return {
                  ...state,
                  nameFocused: true
                }
              })
            }}
            onBlur={() => {
              setState(state => {
                return {
                  ...state,
                  nameFocused: false
                }
              })
            }} />
        </Form.Group>
        <Form.Group controlId="pageDescription" className={styles.group}>
          <Form.Label className={styles.label}>Page Meta description</Form.Label>
          <Form.Control
            as="textarea"
            className={styles.control}
            type="text"
            name="description"
            placeholder="Enter page description"
            value={state.descriptionFocused ? _.get(value, 'twitter.description') : description}
            onChange={handleDescriptionChange}
            onFocus={() => {
              setState(state => {
                return {
                  ...state,
                  descriptionFocused: true
                }
              })
            }}
            onBlur={() => {
              setState(state => {
                return {
                  ...state,
                  descriptionFocused: false
                }
              })
            }} />
        </Form.Group>
      </Form>
      <MediaLibraryModal
        show={state.library}
        storyboard={storyboardContext}
        multiple={false}
        onSelect={handleCreateImage}
        onClose={handleCloseMediaLibrary}
        mediaTarget={'social_share'}
      />
    </div>
  )
}

const Handle = React.forwardRef((props, ref) => {
  return (
    <div className={styles.handle} ref={ref}>
      <div className={styles.line}>
        {_.times(2).map((index) => {
          return <span key={index} />;
        })}
      </div>
      <div className={styles.line}>
        {_.times(2).map((index) => {
          return <span key={index} />;
        })}
      </div>
      <div className={styles.line}>
        {_.times(2).map((index) => {
          return <span key={index} />;
        })}
      </div>
    </div>
  );
});

const SaveMessageModal = ({ show, onSave, onDiscard }) => {
  return (
    <Modal backdrop='static'
      className={styles.saveChangeModal}
      contentClassName={styles.saveChangeContent}
      dialogClassName={styles.saveChangeDialog}
      backdropClassName={styles.backdropWrapper}
      show={show}
      centered size="lg"
    >
      <Modal.Body className={styles.saveChangeBody}>
        <Image src={'/images/saveChanges.png'} className={styles.saveMessageImage} />
        <Row className={styles.messageRow}>
          <Col className={styles.messageContainer} xs={{ span: 6, offset: 6 }}>
            <h2 className={styles.messageTitle}>Wait, what?</h2>
            <span className={styles.messageContent}>
              Changes made to this mission<br /> haven’t been saved. Sure you<br /> want to continue?
            </span>
            <footer className={styles.saveChangeButtons}>
              <Button variant="secondary" onClick={onDiscard} >Discard</Button>
              <Button variant="primary" onClick={onSave} >Save Changes</Button>
            </footer>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  )
}